// Einzige Stelle für den Status der Pilotanlage Kantstraße (Stand 04.11.2026: zurückgebaut).
const WHERE_DE =
  "Von Juni bis September 2026 stand die erste vollständige Anlage in der Berliner Kantstraße, zwischen Waldorf Astoria und Upper West — bepflanzt, beleuchtet, begehbar.";
const WHERE_EN =
  "From June to September 2026, the first complete installation stood on Berlin's Kantstraße, between the Waldorf Astoria and Upper West — planted, lit, walkable.";

export const KANT = {
  de: {
    title: "Juni bis September 2026 in der Kantstraße",
    status: "Juni bis September 2026. Ohne Fundament aufgestellt, rückstandslos zurückgebaut.",
    where: WHERE_DE,
    get whereStatus() {
      return `${WHERE_DE} Ohne Fundament aufgestellt, rückstandslos zurückgebaut.`;
    },
  },
  en: {
    title: "June to September 2026 on Kantstraße",
    status: "June to September 2026. Set up without foundations, removed without trace.",
    where: WHERE_EN,
    get whereStatus() {
      return `${WHERE_EN} Set up without foundations, removed without trace.`;
    },
  },
  // Weitere Sprachen: Status-Satz 1:1 aus den Startseiten-Vorlagen (Sprachen-Auftrag 04.11.2026)
  fr: { status: "De juin à septembre 2026. Posé sans fondation, démonté sans laisser de traces." },
  pl: { status: "Od czerwca do września 2026. Ustawiony bez fundamentu, zdemontowany bez śladu." },
  es: { status: "De junio a septiembre de 2026. Instalado sin cimentación, retirado sin dejar rastro." },
  uk: { status: "З червня по вересень 2026 року. Встановлено без фундаменту, демонтовано без жодних слідів." },
  it: { status: "Da giugno a settembre 2026. Posato senza fondazioni, rimosso senza lasciare tracce." },
  nl: { status: "Juni tot september 2026. Geplaatst zonder fundering, spoorloos verwijderd." },
  cs: { status: "Červen až září 2026. Instalováno bez základů, odstraněno beze stop." },
};
